<div class="add-settlement-template-form-container" fxFlex="100" fxLayout="column" fxLayoutGap="15px">
  <div fxLayout="row" fxLayoutGap="15px">
    <button (click)="save()" [class.spinner]="processingRequest"
            [disabled]="!templateForm.valid"
            mat-stroked-button color="primary"><mat-icon>save</mat-icon> <span> Zapisz</span></button>
    <button (click)="cancel()" mat-stroked-button color="warn"><mat-icon>cancel</mat-icon> <span> Anuluj</span></button>
  </div>

  <div fxLayout="row" fxLayoutGap="15px" fxFlex="100" fxLayout.lt-lg="column">
    <div fxFlex="100" fxFlex.lt-md="100" fxLayoutGap="15px">
      <mat-card fxLayout="column" fxFlex="100">
        <div fxLayout="row" fxFlex="100" fxLayoutGap="15px" fxLayoutAlign="center center">
          <div fxFlex="25" >
            <app-month-picker
              fxFlex="100"
              label="Miesiąc rozliczeniowy" [required]="true"
              [control]="billingMonthControl"
            ></app-month-picker>
          </div>
          <div fxFlex="25" >
            <app-dict
              [label]="'Firma'" [dictType]="'company'"
              [control]="companyControl"
              [required]="true"
              [multiple]="false"
            ></app-dict>
          </div>
          <div fxFlex="25">
            <app-dict
              [label]="'Rodzaj rozliczenia'" [dictType]="'type_of_settlement'"
              [control]="typeOfSettlementControl"
              [required]="true"
              [multiple]="false"
            ></app-dict>
          </div>
          <div fxFlex="25">
            <button (click)="copy()" mat-stroked-button color="primary"><mat-icon>content_copy</mat-icon> <span> Wklej treść z miesiąca poprzedniego</span></button>

            <!--            <button (click)="download()" [disabled]="!billingMonthControl.value || !companyControl.value || !typeOfSettlementControl.value" mat-stroked-button color="primary"><mat-icon>download</mat-icon> <span> Pobierz</span></button>-->
          </div>
        </div>
        <div fxLayout="column" fxFlex="100" fxFlex.lt-md="100" fxLayoutGap="15px">
            <div fxLayout="row" fxLayoutAlign="space-between center" >
              <h3>Aktualny szablon</h3>
            </div>
            <angular-editor fxFlex="100"  [config]="editorConfig" [formControl]="contentControl" [required]="false"></angular-editor>
          </div>
        <div fxLayout="column" fxFlex.lt-md="100%" >
          <h3>Zmienne do wykorzystania w szablonie</h3>

<!--          <table mat-table [dataSource]="dataSource" >-->
<!--            <ng-container matColumnDef="variable">-->
<!--              <th mat-header-cell *matHeaderCellDef [width]="'350px'">Zmienna</th>-->
<!--              <td mat-cell *matCellDef="let element">-->
<!--                <button style="width: auto" (click)="copyMessage(element.variable)"  mat-icon-button color="primary" matTooltip="{{element.variable}}">{{element.variable}}</button>-->
<!--              </td>-->
<!--            </ng-container>-->
<!--            &lt;!&ndash; Name Column &ndash;&gt;-->
<!--            <ng-container matColumnDef="application">-->
<!--              <th mat-header-cell *matHeaderCellDef>Zastosowanie</th>-->
<!--              <td mat-cell *matCellDef="let element"> {{element.application}} </td>-->
<!--            </ng-container>-->
<!--            <tr mat-header-row *matHeaderRowDef="displayedColumns" ></tr>-->
<!--            <tr mat-row *matRowDef="let row; columns: displayedColumns;" [class]="row"></tr>-->
<!--          </table>-->
          <div class="grid-table">
            <div class="mat-header-cell cdk-header-cell cdk-column-variable mat-column-variable ng-star-inserted">Zmienna</div>
            <div class="mat-header-cell cdk-header-cell cdk-column-variable mat-column-variable ng-star-inserted">Zastosowanie</div>
            <div><button style="width: auto" (click)="copyMessage(tempDefault)"  mat-icon-button color="primary" matTooltip="{{tempDefault}}">{{tempDefault}}</button></div>
            <div>Dowolna treść</div>
            <div> <button style="width: auto" (click)="copyMessage(tempMC)"  mat-icon-button color="primary" matTooltip="{{tempMC}}">{{tempMC}}</button></div>
            <div>Miesiąc rozliczeniowy</div>
            <div> <button style="width: auto" (click)="copyMessage(tempInitialBalance)"  mat-icon-button color="primary" matTooltip="{{tempInitialBalance}}">{{tempInitialBalance}}</button></div>
            <div>Kwota salda do wypłaty</div>
            <div><button style="width: auto" (click)="copyMessage(tempAmount)"  mat-icon-button color="primary" matTooltip="{{tempAmount}}">{{tempAmount}}</button></div>
            <div>Kwota rozliczenia z danego miesiąca rozliczeniowego per Partner</div>
            <div><button style="width: auto" (click)="copyMessage(tempCommissionLess)"  mat-icon-button color="primary" matTooltip="{{tempCommissionLess}}">{{tempCommissionLess}}</button></div>
            <div>Treść maila dla kwota rozliczenia mniejszej od zera ( < 0.00 )</div>
            <div class="gird-table-colspan"><angular-editor fxFlex="100"  [config]="editorConfig" [formControl]="contentCommissionLessControl" [required]="false"></angular-editor></div>
            <div><button style="width: auto" (click)="copyMessage(tempCommissionZero)"  mat-icon-button color="primary" matTooltip="{{tempCommissionZero}}">{{tempCommissionZero}}</button></div>
            <div>Treść maila dla kwoty rozliczenia równej zero ( = 0.00 )</div>
            <div class="gird-table-colspan"><angular-editor fxFlex="100"  [config]="editorConfig" [formControl]="contentCommissionZeroControl" [required]="false"></angular-editor></div>
            <div><button style="width: auto" (click)="copyMessage(tempCommissionHigher)"  mat-icon-button color="primary" matTooltip="{{tempCommissionHigher}}">{{tempCommissionHigher}}</button></div>
            <div>Treść maila dla kwota rozliczenia większa od zera ( > 0.00 )</div>
            <div  class="gird-table-colspan"><angular-editor fxFlex="100"  [config]="editorConfig" [formControl]="contentCommissionHigherControl" [required]="false"></angular-editor></div>
          </div>
        </div>
    </mat-card>
  </div>
</div>


</div>
